import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RequestAd from './RequestAd';
import Adcount from './Adcount';
import AdCore from './AdCore';
import AdPause from './AdPause';
import AdPlaying from './AdPlaying';
import Adbanner from './Adbanner';
import Adcorner from './Adcorner';
import Events from '../event';
import Stat from '../vStat';

class AdVideo extends Component {
    static propTypes = {
        opt: PropTypes.object.isRequired,
        videoinfo: PropTypes.object.isRequired,
        playermsg: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.opt = this.props.opt;
        this.opt = {
            containerDom: 'playerDiv',
            ...this.opt,
        };
        this.videoinfo = this.props.videoinfo;
        this.state = {
            showItem: false,
            isRender: false,
            renderCore: false,
            can: 'no',
            destory: false,
        };
        this.initMuted = false;
    }

    componentDidMount() {
        this.firstbuff = true; // 还剩n秒时标记

        const ad = new RequestAd(this.opt, this.videoinfo);
        let time = 0;

        const fun = (data, obj) => {
            clearInterval(this.timer);
            const dui = {
                ...data,
                obj,
            };

            if (typeof dui.frontAd !== 'undefined') {
                this.can = 'yes';
                this.setState({
                    can: 'yes',
                });
                this.initParams(dui);
                this.initComponent();
                this.trigger('start');
            } else {
                this.can = 'no';
                this.setState({
                    can: 'no',
                });
                this.setState({
                    isRender: true,
                });

                setTimeout(() => {
                    this.trigger('start');
                }, 0);
            }
        };

        this.timer = setInterval(() => {
            time++;

            if (time > 4) {
                ad.off('start', fun);
                this.can = 'no';
                this.trigger('start');
                this.trigger('ended', 5);
                clearInterval(this.timer);
            }
        }, 1000);
        // 监听回调

        ad.on('start', fun);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    initParams(obj) {
        this.RequestAd = Promise.resolve(obj);
    }

    initComponent() {
        const self = this;

        this.RequestAd.then((call) => {
            self.call = call;
            self.frontAd = call.frontAd;
            self.adTime = call.frontAd.adTime;
            self.banner = call.banner;
            self.corner = call.corner;
            self.obj = call.obj;
            self.setState({
                isRender: true,
            });
            self.Adcount = new Adcount(call.obj);
            this.didMount();
        });
    }

    didMount() {
        const vStat = new Stat(this.props.videoinfo);
        const AdCore = this.refs['adCore'];
        const AdPause = this.refs['adPause'];
        const Adbanner = this.refs['adbanner'];
        const Adcorner = this.refs['adcorner'];
        const AdPlaying = this.refs['adPlaying'];
        const Adcount = this.Adcount;

        const self = this;

        let playIndex = 0; // 应该播放的index  还有就是可以拿到的AdCore.dom
        let playflag = false; // 是否播放过

        const frontAd = this.frontAd;
        const adUrl = this.frontAd.adUrl; // 广告地址数组
        const adTime = this.frontAd.adTime; // 广告总时长
        let lastTime = adTime;

        AdCore.on(
            'canplay',
            () => {
                if (playflag === false) {
                    AdCore.adPlay(0); // playIndex
                    AdPlaying.show();
                    vStat.sendVplayer('701010');
                }
                playflag = true;
                self.trigger('canplay');
            },
            AdCore.el[0],
        );

        AdCore.on('mutePlay', () => {
            this.initMuted = true;
            AdPlaying.adVideoMutedPlay();
        });

        // 广告内容绑定事件
        adUrl.forEach((element, index) => {
            let sendPlay = false;
            let first = true;

            AdCore.on(
                'timeupdate',
                () => {
                    const dom = AdCore.dom;

                    if (first === true) {
                        vStat.sendAd('start', '000', frontAd, playIndex);
                        // self.trigger('firstPlay');
                        // ad开始播放后再调高音量
                        AdCore.adStartHVolume();

                        // 根据广告类型决定点击形式
                        if (this.frontAd?.materialType[index] === 'iframe') {
                            AdPlaying.changeLinkClickable(false);
                        } else {
                            AdPlaying.changeLinkClickable(true);
                        }

                        first = false;
                    }

                    Adcount.send(1, playIndex, dom.currentTime);

                    const _this = AdCore.el[index].getDom();

                    // 调用广告统计脚本，参数为video的index和currentTime
                    if (Math.floor(dom.currentTime) === 3 && sendPlay === false) {
                        vStat.sendAd('play', '000', frontAd, playIndex);
                        sendPlay = true;
                    }

                    const second = Math.max(0, Math.round(lastTime - _this.currentTime));

                    // 使用ref的方式取代dom方式，避免同一页面多个播放器情况下只能获取第一个倒计时的问题
                    // document.getElementById('js_video_tip_number').innerHTML = `${second}s`;
                    AdPlaying.adsecond.innerHTML = `${second}s`;

                    if (index === adUrl.length - 1 && second === 3) {
                        if (self.firstbuff === true) {
                            self.trigger('adbuff');
                            self.firstbuff = false;
                        }
                    }
                },
                AdCore.el[index],
            );

            AdCore.on(
                'ended',
                () => {
                    const _this = AdCore.el[index].getDom();

                    lastTime = Math.max(0, Math.round(lastTime - _this.currentTime));
                    // 发送播放器广告播放完成统计
                    vStat.sendAd('finish', '000', frontAd, playIndex);

                    if (adUrl.length > 0 && playIndex + 1 < adUrl.length) {
                        AdCore.adPlay(++playIndex);
                    } else if (playIndex + 1 === adUrl.length) {
                        this.trigger('ended', this.obj);
                    }
                },
                AdCore.el[index],
            );
        });

        const adVolume = AdPlaying.advolume;

        // 静音、取消静音
        adVolume.addEventListener('mousedown', (e) => {
            if (e.button === 0) {
                this.clickData = {
                    startTime: Date.now(),
                };
            }
        });

        adVolume.addEventListener('mouseup', (e) => {
            if (e.button === 0 && this.clickData) {
                this.clickData.endTime = Date.now();
            }
        });

        adVolume.addEventListener('click', (e) => {
            if (this.clickData && this.clickData.startTime) {
                if (!this.clickData.endTime) {
                    this.clickData.endTime = Date.now();
                }

                try {
                    const pointerClientX = e.clientX;
                    const pointerClientY = e.clientY;
                    const {
                        x: adLinkX,
                        y: adLinkY,
                        width: adSpaceWidth,
                        height: adSpaceHeight,
                    } = AdPlaying.adlink2.getBoundingClientRect();
                    const offsetX = pointerClientX - adLinkX;
                    const offsetY = pointerClientY - adLinkY;

                    this.clickData.offsetX = offsetX;
                    this.clickData.offsetY = offsetY;
                    this.clickData.adSpaceWidth = adSpaceWidth;
                    this.clickData.adSpaceHeight = adSpaceHeight;
                } catch (e) {
                    console.error(e);
                    this.clickData = null;
                }
            } else {
                this.clickData = null;
            }

            AdCore.adVolume();
            if (this.initMuted) {
                AdCore.cancelVideoMuted();
                this.initMuted = false;
            }
            const muted = AdPlaying.videoTipVolumeMuteToggle();
            const actionId = muted ? '6' : '5';

            Adcount.sendClick(1, playIndex, this.clickData, actionId, AdCore.dom.currentTime);
        });

        AdPlaying.adlink.addEventListener('mousedown', (e) => {
            if (e.button === 0) {
                this.clickData = {
                    startTime: Date.now(),
                };
            }
        });

        AdPlaying.adlink.addEventListener('mouseup', (e) => {
            if (e.button === 0 && this.clickData) {
                this.clickData.endTime = Date.now();
            }
        });

        // 查看广告详情
        AdPlaying.adlink.addEventListener('click', (e) => {
            if (this.clickData && this.clickData.startTime) {
                if (!this.clickData.endTime) {
                    this.clickData.endTime = Date.now();
                }

                try {
                    const pointerClientX = e.clientX;
                    const pointerClientY = e.clientY;
                    const {
                        x: adLinkX,
                        y: adLinkY,
                        width: adSpaceWidth,
                        height: adSpaceHeight,
                    } = AdPlaying.adlink2.getBoundingClientRect();
                    const offsetX = pointerClientX - adLinkX;
                    const offsetY = pointerClientY - adLinkY;

                    this.clickData.offsetX = offsetX;
                    this.clickData.offsetY = offsetY;
                    this.clickData.adSpaceWidth = adSpaceWidth;
                    this.clickData.adSpaceHeight = adSpaceHeight;
                } catch (e) {
                    console.error(e);
                    this.clickData = null;
                }
            } else {
                this.clickData = null;
            }

            let clickUrl = AdCore.clickUrl;

            if (this.clickData) {
                const { startTime, endTime, offsetX, offsetY, adSpaceWidth, adSpaceHeight } = this.clickData;
                clickUrl = clickUrl
                    .replace('__EVENT_TIME_START__', parseInt(startTime, 10))
                    .replace('__EVENT_TIME_END__', parseInt(endTime, 10))
                    .replace('__OFFSET_X__', parseInt(offsetX, 10))
                    .replace('__OFFSET_Y__', parseInt(offsetY, 10))
                    .replace('__ADSPACE_W__', parseInt(adSpaceWidth, 10))
                    .replace('__ADSPACE_H__', parseInt(adSpaceHeight, 10))
                    .replace('__VIDEO_ACTION_ID__', '2');
            }

            // 发送播放器广告点击统计
            window.open(clickUrl); // 核心
            vStat.sendAd('click', '000', frontAd, playIndex);
            Adcount.sendClick(1, playIndex, this.clickData, '2', AdCore.dom.currentTime);
        });

        AdPlaying.adlink2.addEventListener('mousedown', (e) => {
            if (e.button === 0) {
                this.clickData = {
                    startTime: Date.now(),
                };
            }
        });

        AdPlaying.adlink2.addEventListener('mouseup', (e) => {
            if (e.button === 0 && this.clickData) {
                this.clickData.endTime = Date.now();
            }
        });

        AdPlaying.adlink2.addEventListener('click', (e) => {
            if (this.clickData && this.clickData.startTime) {
                if (!this.clickData.endTime) {
                    this.clickData.endTime = Date.now();
                }

                try {
                    const pointerClientX = e.clientX;
                    const pointerClientY = e.clientY;
                    const {
                        x: adLinkX,
                        y: adLinkY,
                        width: adSpaceWidth,
                        height: adSpaceHeight,
                    } = AdPlaying.adlink2.getBoundingClientRect();
                    const offsetX = pointerClientX - adLinkX;
                    const offsetY = pointerClientY - adLinkY;

                    this.clickData.offsetX = offsetX;
                    this.clickData.offsetY = offsetY;
                    this.clickData.adSpaceWidth = adSpaceWidth;
                    this.clickData.adSpaceHeight = adSpaceHeight;
                } catch (e) {
                    console.error(e);
                    this.clickData = null;
                }
            } else {
                this.clickData = null;
            }

            let clickUrl = AdCore.clickUrl;

            if (this.clickData) {
                const { startTime, endTime, offsetX, offsetY, adSpaceWidth, adSpaceHeight } = this.clickData;
                clickUrl = clickUrl
                    .replace('__EVENT_TIME_START__', parseInt(startTime, 10))
                    .replace('__EVENT_TIME_END__', parseInt(endTime, 10))
                    .replace('__OFFSET_X__', parseInt(offsetX, 10))
                    .replace('__OFFSET_Y__', parseInt(offsetY, 10))
                    .replace('__ADSPACE_W__', parseInt(adSpaceWidth, 10))
                    .replace('__ADSPACE_H__', parseInt(adSpaceHeight, 10))
                    .replace('__VIDEO_ACTION_ID__', '2');
            }

            window.open(clickUrl);
            // 发送播放器广告点击统计
            vStat.sendAd('click', '000', frontAd, playIndex);
            Adcount.sendClick(1, playIndex, this.clickData, '2', AdCore.dom.currentTime);
        });

        Adbanner.el.addEventListener('click', (e) => {
            if (typeof frontAd.banner == 'undefined') return;
            if (!frontAd.banner.goUrl) return;
            window.open(frontAd.banner.goUrl);
            e.stopPropagation();
            Adcount.sendClick(5, 0, null, '2', AdCore.dom.currentTime);
        });

        Adcorner.el.addEventListener('click', (e) => {
            if (typeof frontAd.corner == 'undefined') return;
            if (!frontAd.corner.goUrl) return;
            window.open(frontAd.corner.goUrl);
            e.stopPropagation();
            Adcount.sendClick(4, 0, null, '2', AdCore.dom.currentTime);
        });

        AdPause.pauseClose.addEventListener('click', (e) => {
            AdPause.adVipClose();

            if (this.refs['adCore']) {
                AdCore.dom.play();
            }

            e.stopPropagation();
            e.preventDefault();
        });
    }

    cancleAdCoreMuted() {
        const AdCore = this.refs['adCore'];

        if (AdCore) {
            if (this.initMuted) {
                AdCore.cancelVideoMuted();
                this.initMuted = false;
            }
        } else {
            setTimeout(() => {
                this.cancleAdCoreMuted();
            }, 200);
        }
    }

    bannerAdShow() {
        const adbanner = this.refs['adbanner'];

        if (typeof this.can == 'undefined' || this.can === 'no') return;
        const call = this.call;
        // call = {
        //     frontAd: { banner: { imgUrl: '//p1.ifengimg.com/a/2016/1021/pause.jpg?vip' } },
        // };
        const frontAd = call.frontAd;

        if (frontAd.banner) {
            let bannerimg = null;

            if (frontAd.banner.imgUrl.indexOf('.html') > -1) {
                // iframe的素材
                bannerimg = document.createElement('iframe');
                bannerimg.src = frontAd.banner.imgUrl;

                bannerimg.setAttribute('width', '100%');
                bannerimg.setAttribute('height', '100%');
                bannerimg.setAttribute('scrolling', 'no');
                bannerimg.setAttribute('frameborder', 'no');
                bannerimg.setAttribute('border', '0');
            } else {
                // 图片素材
                bannerimg = new Image();
                // bannerimg.src = "//p1.ifengimg.com/a/2016/1021/pause.jpg?vip";
                bannerimg.src = frontAd.banner.imgUrl;
            }
            const jsBanner = adbanner.el;

            jsBanner.insertBefore(bannerimg, jsBanner.childNodes[0]);
            adbanner.show();

            // 设置定时器，5s钟关闭banner广告
            this.bannerTimer = setTimeout(() => {
                adbanner.hide();
            }, 10000);

            // 发送banner广告统计，5为banner广告，index参数为0
            this.Adcount.send(5, 0);
        }
    }

    cornerAdShow() {
        const adcorner = this.refs['adcorner'];

        if (typeof this.can == 'undefined' || this.can === 'no') return;
        const call = this.call;
        // call = {
        //     frontAd: { corner: { imgUrl: '//p1.ifengimg.com/a/2016/1021/pause.jpg?vip' } },
        // };
        const Adcount = this.Adcount;
        const frontAd = call.frontAd;

        if (frontAd.corner) {
            const cornerimg = new Image();

            cornerimg.src = frontAd.corner.imgUrl;
            const jsCorner = adcorner.el;

            jsCorner.insertBefore(cornerimg, jsCorner.childNodes[0]);
            // $(jsCorner).removeClass('connerAdHide');
            adcorner.cornerShow();
            // 发送暂停广告统计:4为角标广告，index为0
            Adcount.send(4, 0);
        }
    }

    pauseAdShow() {
        const adPause = this.refs['adPause'];

        this.AdPause = adPause;
        const oobj = {
            type: 'pause',
            adType: this.opt.adType || '5',
            subject: this.opt.subject || '',
            frmid: this.opt.frmid || 'free',
        };

        if (this.videoinfo.categoryId) {
            const ptype = this.videoinfo.categoryId.split('-')[0];

            if (ptype === '154') {
                oobj.adType = '4';
                oobj.frmid = 'vdocumentary';
            }
        }
        const ad = new RequestAd(oobj, this.videoinfo);

        ad.on('start', (data, obj) => {
            const _adCount = new Adcount(obj);
            const pauseData = data.pause;

            if (pauseData && pauseData.materialUrl) {
                const { materialUrl, materialType = 'img', materialWidth, materialHeight, clickUrl } = pauseData;

                // 显示暂停广告
                adPause.adVip({ url: materialUrl, type: materialType, width: materialWidth, height: materialHeight });

                adPause.pauseLink.addEventListener('mousedown', (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    if (e.button === 0) {
                        this.clickData = {
                            startTime: Date.now(),
                        };
                    }
                });

                adPause.pauseLink.addEventListener('mouseup', (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    if (e.button === 0 && this.clickData) {
                        this.clickData.endTime = Date.now();
                    }
                });

                // 暂停广告点击事件（使用on而非addEventListener达到每次替换的效果）
                adPause.pauseLink.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    // img类型在此打开新窗口，iframe类型内部控制
                    if (materialType === 'img') {
                        if (this.clickData && this.clickData.startTime) {
                            if (!this.clickData.endTime) {
                                this.clickData.endTime = Date.now();
                            }

                            try {
                                const pointerClientX = e.clientX;
                                const pointerClientY = e.clientY;
                                const {
                                    x: adLinkX,
                                    y: adLinkY,
                                    width: adSpaceWidth,
                                    height: adSpaceHeight,
                                } = adPause.pauseLink.getBoundingClientRect();
                                const offsetX = pointerClientX - adLinkX;
                                const offsetY = pointerClientY - adLinkY;

                                this.clickData.offsetX = offsetX;
                                this.clickData.offsetY = offsetY;
                                this.clickData.adSpaceWidth = adSpaceWidth;
                                this.clickData.adSpaceHeight = adSpaceHeight;
                            } catch (e) {
                                console.error(e);
                                this.clickData = null;
                            }
                        } else {
                            this.clickData = null;
                        }

                        let macroUrl = clickUrl;

                        if (this.clickData) {
                            const { startTime, endTime, offsetX, offsetY, adSpaceWidth, adSpaceHeight } =
                                this.clickData;
                            macroUrl = macroUrl
                                .replace('__EVENT_TIME_START__', parseInt(startTime, 10))
                                .replace('__EVENT_TIME_END__', parseInt(endTime, 10))
                                .replace('__OFFSET_X__', parseInt(offsetX, 10))
                                .replace('__OFFSET_Y__', parseInt(offsetY, 10))
                                .replace('__ADSPACE_W__', parseInt(adSpaceWidth, 10))
                                .replace('__ADSPACE_H__', parseInt(adSpaceHeight, 10));
                        }

                        window.open(macroUrl);
                        _adCount.sendClick(3, _adCount.pauseAds.length - 1, this.clickData, '2');
                    }
                };

                // 发送暂停广告统计:3为暂停广告，index为0
                _adCount.send(3, 0);
            }
        });
    }

    show = () => {
        this.setState({
            showItem: true,
        });
    };
    hide = () => {
        this.setState({
            showItem: false,
        });
    };

    play() {
        // this.el.play();
    }

    pause() {
        // this.el.pause();
    }

    destory() {
        this.setState({
            destory: true,
        });
    }

    render() {
        const { playermsg } = this.props;
        const { isRender, can, destory } = this.state;

        let renderChildren = destory
            ? [
                  <AdPause ref="adPause" key="adpause" />,
                  <Adbanner ref="adbanner" key="adbanner" />,
                  <Adcorner ref="adcorner" key="adcorner" />,
              ]
            : [
                  <AdCore ref="adCore" key="adcore" frontAd={this.frontAd} playermsg={playermsg} />,
                  <AdPause ref="adPause" key="adpause" />,
                  <AdPlaying ref="adPlaying" key="adplaying" frontAd={this.frontAd} adTime={this.adTime} />,
                  <Adbanner ref="adbanner" key="adbanner" />,
                  <Adcorner ref="adcorner" key="adcorner" />,
              ];

        if (can === 'no') {
            renderChildren = [
                <AdPause ref="adPause" key="adpause" />,
                <Adbanner ref="adbanner" key="adbanner" />,
                <Adcorner ref="adcorner" key="adcorner" />,
            ];
        }

        if (!isRender) {
            renderChildren = null;
        }

        return renderChildren;
    }
}

Events.mixTo(AdVideo);
export default AdVideo;
